// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import paymentSuccessSVG from '../../../../assets/img/payment-success.svg';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {connect} from 'react-redux';

import type {
  Store,
  User,
  Subscription,
  SubscriptionSetting,
} from '../../../../entities';
import type {RootState} from '../../../index';
import {getStringDate} from '../../../../utils/date';
import {useHistory} from 'react-router-dom';
import {
  MAP_FREE_TRIAL_NAME,
  MAP_SINGLE_PLAN_NAME,
} from '../../../store/utils/utils_tier';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    subscription: state.tiersList.currentSubscription,
    subscriptionSetting: state.accountConfig.subscriptionSetting,
    saveSubscriptionSettingSuccess: state.accountConfig.savingSuccess,
  }),
  null
)(PlanChangeSuccessModal);

type Props = {|
  user?: User,
  store?: Store,
  saveSubscriptionSettingSuccess?: boolean,
  subscription?: Subscription,
  subscriptionSetting?: SubscriptionSetting,
|};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 564,
    maxWidth: '100%',
    padding: theme.spacing(2, 0),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginTop: theme.spacing(1),
    '& span': {
      color: colors.purple,
    },
  },
  text: {
    marginTop: theme.spacing(3),
    color: colors.grey900,
  },
  bold: {fontWeight: 600},
  button: {
    height: 48,
    // borderRadius: '8px',
    marginTop: theme.spacing(2),
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '4px 80px',
    maxWidth: '100%',
  },
  mainContent: {
    border: `2px solid ${colors.grey300}`,
    borderRadius: '24px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // alignItems: 'center',
    margin: theme.spacing(3, 0),
    padding: theme.spacing(3),
  },
  planLineTitle: {
    width: 160,
    fontSize: '1.25rem',
    fontWeight: 600,
    whiteSpace: 'nowrap,',
  },
}));

function PlanChangeSuccessModal(props: Props) {
  const {
    user,
    store,
    subscription,
    subscriptionSetting,
    // saveSubscriptionSettingSuccess,
  } = props;

  const classes = useStyles();
  const history = useHistory();

  const handleClosePlanChangeSuccessModal = () => {
    history.push('/');
    window.location.reload(false);
  };

  const handleClickConfirm = () => {
    handleClosePlanChangeSuccessModal();
  };

  return (
    <CustomModal open handleCloseModal={handleClosePlanChangeSuccessModal}>
      {store && subscription && (
        <div className={classes.root}>
          <img src={paymentSuccessSVG} alt="" />
          <Typography className={classes.title} align="center">
            <span>{user ? user.firstName : ''}</span>
            {user && <br />}
            Tu suscripción fue actualizada.
          </Typography>
          <Typography className={classes.text} align="center">
            {`El día ${getStringDate(
              subscription.endDate
            )} procederemos a realizar el cobro automático de la suscripción.`}
          </Typography>
          <div className={classes.mainContent}>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
              <Typography className={classes.planLineTitle}>
                Plan actual
              </Typography>
              <div>
                <Typography>
                  <span className={classes.bold}>Plan: </span>{' '}
                  {`${MAP_SINGLE_PLAN_NAME[store.storeTier.name]} - ${
                    {
                      MONTHLY: 'Mensual',
                      QUARTERLY: 'Trimestral',
                      ANNUAL: 'Anual',
                    }[subscription.storeTierPlan.frequency.name]
                  } ${MAP_FREE_TRIAL_NAME[store.storeTier.name] || ''}`}
                </Typography>
                <Typography>
                  <span className={classes.bold}>Fecha de inicio: </span>{' '}
                  {getStringDate(subscription.startDate)}
                </Typography>
                <Typography>
                  <span className={classes.bold}>Fecha de fin: </span>{' '}
                  {getStringDate(subscription.endDate)}
                </Typography>
              </div>
            </div>
            <div style={{display: 'flex', flexWrap: 'wrap', marginTop: 16}}>
              <Typography className={classes.planLineTitle}>
                Próximo plan
              </Typography>
              <div>
                <Typography>
                  <span className={classes.bold}>Plan: </span>{' '}
                  {subscriptionSetting &&
                    subscriptionSetting.storeTierPlan &&
                    `${
                      MAP_SINGLE_PLAN_NAME[
                        subscriptionSetting.storeTierPlan.storeTier.name
                      ]
                    } - ${
                      {
                        MONTHLY: 'Mensual',
                        QUARTERLY: 'Trimestral',
                        ANNUAL: 'Anual',
                      }[subscriptionSetting.storeTierPlan.frequency.name]
                    }`}
                </Typography>
                <Typography>
                  <span className={classes.bold}>Fecha de inicio: </span>{' '}
                  {getStringDate(subscription.endDate)}
                </Typography>
                <Typography>
                  <span className={classes.bold}>Fecha de fin: </span>{' '}
                  {getStringDate(
                    new Date(subscription.endDate).setMonth(
                      new Date(subscription.endDate).getMonth() +
                        (!!subscriptionSetting &&
                        !!subscriptionSetting.storeTierPlan
                          ? {
                              MONTHLY: 1,
                              QUARTERLY: 3,
                              ANNUAL: 12,
                              SEMIANNUALLY: 6,
                            }[subscriptionSetting.storeTierPlan.frequency.name]
                          : 0)
                    )
                  )}
                </Typography>
              </div>
            </div>
          </div>
          <CustomButton
            variant="contained"
            className={classes.button}
            onClick={handleClickConfirm}
          >
            Cerrar
          </CustomButton>
        </div>
      )}
    </CustomModal>
  );
}

PlanChangeSuccessModal.propTypes = {
  user: PropTypes.object,
  store: PropTypes.object,
  subscription: PropTypes.object,
  saveSubscriptionSettingSuccess: PropTypes.bool,
  subscriptionSetting: PropTypes.object,
};
